
import React, { PropTypes } from 'react';
import CSSModules           from 'react-css-modules';
import { reduxForm }        from 'redux-form';

import style from './style.scss';

import presenterRepository from '../../services/presenters';
import formInitialiser     from '../../services/formInitialiser';
import FormSubmitter       from '../../services/formSubmitter';

import Button        from '../Button';
import Input         from '../Input';
import InlineError   from '../InlineError';
import HtmlEditor    from '../HtmlEditor';
import InputGroup    from '../InputGroup';
import InputSection  from '../InputSection';
import Label         from '../Label';

class PresenterForm extends React.Component {

    render() {

        const { fields: { name, bio }, handleSubmit, submitting } = this.props;

        const submitSuccess = this.props.submitSuccess;
        
        var formSubmitter = new FormSubmitter({
            create: presenterRepository.create,
            update: presenterRepository.update,
            submitSuccess: submitSuccess
        });

        return (
            <form onSubmit={ handleSubmit(formSubmitter.getSubmit(this.props.mode)) }>

                <InputSection>

                    <InputGroup>
                        <Label>Name</Label>
                        <Input { ...name } errors={ name.error } />
                        <InlineError errors={ name.error } />
                    </InputGroup>

                    <InputGroup>
                        <Label>Biography</Label>

                        <HtmlEditor { ...bio }
                            errors={ bio.error }
                            contentsClassName={ style['presenter-bio-editor'] }>
                        </HtmlEditor>

                        <InlineError errors={ bio.error } />
                    </InputGroup>

                </InputSection>

                <div styleName="action-panel">

                    <Button onClick={ this.props.cancel }
                            styleName="action-button"
                            type="button"
                            theme="secondary">

                        <span>Cancel</span>

                    </Button>

                    <Button disabled={ submitting }
                            styleName="action-button"
                            type="submit"
                            theme="success">

                        <span>Save</span>

                    </Button>

                </div>

            </form>
        );
    }
}

const reduxFormParams = {
    form: 'presenter',
    fields: ['id', 'name', 'bio']
};

function mapStateToProps(state) {

    const { formMode, defaultForm, presenterToEdit } = state.presenterList;

    return {
        initialValues: formInitialiser.getInitialValues(formMode, defaultForm, presenterToEdit),
        mode: formMode
    };
}

export default reduxForm(reduxFormParams, mapStateToProps)(CSSModules(PresenterForm, style));


// WEBPACK FOOTER //
// ./components/PresenterForm/index.js